module.exports = __webpack_public_path__ + "static/img/pic_no_network_big.56836d01.png";